const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
const LOLA_API_URL = process.env.REACT_APP_LOLA_URL || '';

export { API_BASE_URL, LOLA_API_URL };
